import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

import { HeroHeader } from '@/components/dashboard/HeroHeader';
import { GlobalIndicators } from '@/components/dashboard/GlobalIndicators';
import { SecondaryKpis } from '@/components/dashboard/SecondaryKpis';
import { RiskGauges } from '@/components/dashboard/RiskGauges';
import { ChartsGrid } from '@/components/dashboard/ChartsGrid';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [lotes, setLotes] = useState([]);
  const [ofertas, setOfertas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [statsRes, lotesRes, ofertasRes, clientesRes] = await Promise.all([
        axios.get(`${API}/stats`),
        axios.get(`${API}/lotes`),
        axios.get(`${API}/ofertas`),
        axios.get(`${API}/clientes?includeDeleted=true`),
      ]);
      setStats(statsRes.data);
      setLotes(lotesRes.data);
      setOfertas(ofertasRes.data);
      setClientes(clientesRes.data);
    } catch (error) {
      console.error('Error loading stats:', error);
      toast.error('Error al cargar estadísticas');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroHeader />
      <GlobalIndicators stats={stats} />
      <SecondaryKpis stats={stats} />
      <RiskGauges stats={stats} />
      <ChartsGrid lotes={lotes} ofertas={ofertas} clientes={clientes} stats={stats} />
    </div>
  );
};

export default Dashboard;